// ----------------------------------------------------------------------

export default function Link(theme) {
  return {
    MuiLink: {
      defaultProps: {
        color: theme.palette.mode === 'light' ? 'primary' : 'inherit',
      },

      styleOverrides: {
        root: {},
      },
    },
  };
}
